import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';

const Alert = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_2B};
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Spacings.SPACING_5B};
  color: var(--color-i-red);
  word-wrap: break-word;
`;

const WarningIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const CbtCentresFullAlert = () => (
  <Alert>
    <WarningIcon src={getImage('checkout/warning-red.svg')} alt="" />
    Centres are full. No seats available.
  </Alert>
);

export default CbtCentresFullAlert;
